import { IUploadJSONObject } from './types';

/** 5Mb */
export const MAX_FILE_SIZE = 5 * 1024 * 1024;
/** 50 characters */
export const MAX_ID_LENGTH = 50;
/** 255 characters */
export const MAX_PREVIEW_URL_LENGTH = 255;

export const JSON_FIELDS: (keyof IUploadJSONObject)[] = ['id', 'pages', 'previewUrl'] as const;
export const JSON_PAGE_FIELDS: (keyof IUploadJSONObject['pages'][number])[] = [
  'id',
  'imageUrl',
  'position',
] as const;
